import AccountAccessModal from 'components/Account/AccountAccess/AccountAccessModal'
import TextButton from 'LuxKit/Button/TextButton'
import ModalContext from 'contexts/ModalContext'
import React, { MouseEventHandler, useCallback, useContext, useMemo } from 'react'
import { useIntl } from 'react-intl'

function SearchTileSignUpButton() {
  const intl = useIntl()
  const showModal = useContext(ModalContext)
  const handleClick = useCallback<MouseEventHandler<HTMLButtonElement>>((event) => {
    event.preventDefault()
    showModal(<AccountAccessModal />)
  }, [showModal])

  const signUpText = useMemo(() => intl.formatMessage({
    id: 'G6PY2Z3nzE',
    defaultMessage: 'Sign up for free',
    description: 'Sign up button text on search tiles',
  }), [intl])

  return <TextButton kind="secondary" nonInteractable onClick={handleClick}>
    {signUpText}
  </TextButton>
}

export default SearchTileSignUpButton
